import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const KEY = "cellar_cookie_notice";

export const CookieNotice = () => {
  const [seen, setSeen] = useState(() => localStorage.getItem(KEY) === "1");
  if (seen) return null;
  const ok = () => {
    localStorage.setItem(KEY, "1");
    setSeen(true);
  };
  return (
    <div className="no-print fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-xl border border-[#4A3B43] bg-[#161214]/95 backdrop-blur-xl p-5 shadow-2xl rise" data-testid="cookie-notice">
      <p className="text-sm text-[#C9C0B4] leading-relaxed">
        Usamos apenas cookies necessários para manter a sua sessão iniciada. Não usamos cookies de publicidade nem de estatística.{" "}
        <Link to="/cookies" className="text-[#D4AF37] underline underline-offset-2" data-testid="cookie-notice-link">Saber mais</Link>
      </p>
      <Button onClick={ok} className="mt-4 h-10 w-full bg-[#5C1D24] hover:bg-[#8C2B36] text-[#F5F0EB]" data-testid="cookie-notice-accept">Compreendi</Button>
    </div>
  );
};
